import { render, staticRenderFns } from "./helpTree2.vue?vue&type=template&id=2aef799e"
import script from "./helpTree2.vue?vue&type=script&lang=js"
export * from "./helpTree2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports